import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function HealthInsuranceStep(): ReactElement {
  const dispatch = useDispatch();
  const { healthInsurancePossessed: healthInsurancePossessed } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('has_health_ins');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Health Insurance"
          subHeader=" We'll ask you a few questions about the coverage you currently have."
        />
      </GrayCard>

      <CardPadding>
        <CardHeader header="Do you have health insurance?" />
        <Formik
          initialValues={{ healthInsurancePossessed }}
          onSubmit={onSubmit}
          validationSchema={createYesNoObjectSchema('healthInsurancePossessed')}
        >
          <Form ref={formRef}>
            <YesOrNoStepCreator name="healthInsurancePossessed" />

            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { HealthInsuranceStep };
